<template>
	<div class="text-center p-5">
		<p class="text-secondary">4<i class="fa-regular fa-grin-beam-sweat"></i>4</p>
		<p class="text-secondary">The page you are looking for cannot be found.</p>
	</div>
</template>

<script>
export default {
	name: 'PageNotFound',
};
</script>

<style scoped>
div p:nth-of-type(1) {
	font-size: 10em;
}
div p:nth-of-type(2) {
	font-size: 1.6em;
}
i {
	font-size: 0.85em;
}
</style>
